import { render } from "./ProfileView.vue?vue&type=template&id=0c5e1e67"
import script from "./ProfileView.vue?vue&type=script&lang=js"
export * from "./ProfileView.vue?vue&type=script&lang=js"
script.render = render

export default script